<template>
</template>

<script>
export default {
  name: 'HistoryBack',
  props: ['height', 'chartType', 'queryColumns', 'queryResult', 'setupToken', 'queryID', 'queryParams', 'queryMeta', 'embedded', 'selected'],

  data() {
    return {
      parsedSetupToken:{}
    }
  },

  methods: {
  },

  async mounted() {
    console.log("mounted of HistoryBack Plugin...")
    if(this.queryParams){
      window.location = this.queryParams
    } else{
      window.history.go(-1)
    }
  }
}

</script>

